import { Box } from "@mui/material";
import Modal from "../../components/Modal/Modal";
import TimesheetTable from "../../components/Table/TimesheetTable";
import { useTimesheetViewModel } from "./TimesheetViewModel";
import { useState } from "react";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import { useLoading } from "../../contexts/LoadingContext";

const Timesheet = () => {
  const {
    timesheetEntries,
    projects,
    loading,
    error,
    handleRowSave,
    addNewRow,
    handleDelete,
    handleSubmit,
    handleSave,
    fetchActivitiesForProject,
    fetchMilestoneActivityMappings,
    fridays,
    selectedFriday,
    handleFridayChange,
    handleDateChange,
    isDraft,
    handleProjectChange,
    successModal,
    setSuccessModal,
    lastSavedDate,
    holidays,
  } = useTimesheetViewModel();
  const [deleteConfirmation, setDeleteConfirmation] = useState(null);
 const { showLoading, hideLoading } = useLoading();
  const handleError = (errorData) => {
    setSuccessModal(errorData);
  };

  const handleModalClose = () => {
    setSuccessModal(null);
  };
  const handleDeleteClick = (timesheet) => {
    if(timesheet.id.startsWith("temp-")){
      handleDelete(timesheet);
      return;
    }
    setDeleteConfirmation({
      timesheet,
      open: true,
    });
  };
  const handleDeleteConfirm = async () => {
    const timesheet = deleteConfirmation.timesheet;
    try {
      showLoading();
      await handleDelete(timesheet);
      setDeleteConfirmation(null);
      setSuccessModal({
        type: "success",
        title: "Success",
        message: "Timesheet entry deleted successfully",
      });
    } catch (error) {
      setSuccessModal({
        type: "error",
        title: "Action Failed",
        message: error.message || "Failed to delete timesheet",
      });
    } finally {
      hideLoading();
    }
  };

  return (
    <>
      <Box sx={{ p: 0 }}>
        <TimesheetTable
          data={timesheetEntries}
          onAdd={addNewRow}
          onDelete={handleDeleteClick}
          onSave={handleRowSave}
          onSaveTimesheet={handleSave}
          projects={projects}
          fetchActivitiesForProject={fetchActivitiesForProject}
          fetchMilestoneActivityMappings={fetchMilestoneActivityMappings}
          handleSubmit={handleSubmit}
          fridays={fridays}
          selectedFriday={selectedFriday}
          onFridayChange={handleFridayChange}
          onDateChange={handleDateChange}
          isDraft={isDraft}
          onProjectChange={handleProjectChange}
          onError={handleError}
          lastSavedDate={lastSavedDate}
          holidays={holidays}
        />

        {successModal && (
          <Modal
            type={successModal.type}
            title={successModal.title}
            message={successModal.message}
            onClose={handleModalClose}
          />
        )}
      </Box>

      {deleteConfirmation && (
        <ConfirmationModal
          open={true}
          title="Delete Timesheet Entry"
          message={`Are you sure you want to delete timesheet entry ?`}
          onClose={() => setDeleteConfirmation(null)}
          onConfirm={handleDeleteConfirm}
        />
      )}
    </>
  );
};

export default Timesheet;
